import { Action, Middleware } from "redux";
import { EntityType } from "~/common/enums";
import { RequestErrorAction } from "~/Redux/Middleware/apiMiddleware";
import { reloadLocation } from "~/utils/urlUtils";
import { ActionTypes } from "../actions";
import { AIForecastState } from "../reducers";

export const predictionFailed: Middleware<{}, AIForecastState> = store => next => (action: Action) => {
    if (action.type === ActionTypes.GET_DURATION_FAILURE) {
        const errorAction = action as RequestErrorAction;
        if (errorAction.responseInfo.statusCode === 403) {
            const objectInfo = {
                entityName: EntityType.Project,
                objectKey: errorAction.requestData.projectId,
                dialogOnCloseCallback: reloadLocation,
            };
            ep.common.publishObjectNotFound(objectInfo);
            ep.errorManager.handleObjectNotFoundError(objectInfo);
        } else {
            ep.errorManager.handleUnknownError();
        }
    }

    return next(action);
};
